import { useEffect, useState, RefObject } from 'react';

import { IEventTag } from '../../../../../types/working-model';

const RESIZER_DEBOUNCE_TIMEOUT = 300;

type TUseGetAdjustedTagsCount = (params: {
	tags: IEventTag[],
	tagsContainerRef?: RefObject<HTMLDivElement>
}) => {
	showedTags: IEventTag[];
	hiddenTags: IEventTag[]
};

export const useGetAdjustedTagsCount: TUseGetAdjustedTagsCount = ({ tags,  tagsContainerRef}) => {
	const [adjustedTagsCount, setAdjustedTagsCount] = useState(tags?.length);
	
	useEffect(() => {
		const recalculateTagsCount = (): void => {
			if (!tagsContainerRef?.current || !tagsContainerRef?.current.parentElement) return;
			
			// NOTE: We need this to correctly calculate number of showed tags (TK)
			const reservedTagSpace = 20;
			const reservedContainerSpace = 50;
			
			const containerWidth = tagsContainerRef?.current.parentElement?.getBoundingClientRect().width - reservedContainerSpace;
			
			let calculatedTagsWidth = 0;
			let count = 0;
			
			const tagElementsList = Array.from(tagsContainerRef.current.children);
			
			tagElementsList.forEach((child) => {
				const childWidth = child.getBoundingClientRect().width + reservedTagSpace;
				
				calculatedTagsWidth += childWidth;
				
				if (calculatedTagsWidth <= containerWidth) {
					count++;
				}
			});
			
			setAdjustedTagsCount(count);
		};
		
		let waitTimeout: ReturnType<typeof setTimeout>;
		
		const observer = new ResizeObserver(() => {
			if (waitTimeout) clearTimeout(waitTimeout);
			
			waitTimeout = setTimeout(() => {
				recalculateTagsCount();
			}, RESIZER_DEBOUNCE_TIMEOUT);
		});
		
		if (tagsContainerRef?.current?.parentElement) {
			observer.observe(tagsContainerRef?.current.parentElement);
		}
		
		recalculateTagsCount();
		
		return (): void => observer.disconnect();
	}, [tagsContainerRef]);
	
	const showedTags = tags?.slice(0, adjustedTagsCount);
	const hiddenTags = tags?.slice(adjustedTagsCount);
	
	return { showedTags, hiddenTags };
};
